import React, { memo } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = memo(({ children }) => {
  const { currentUser, loading } = useAuth();

  // Only log in development
  if (process.env.NODE_ENV === 'development') {
    console.log('ProtectedRoute:', { 
      currentUser: currentUser ? 'User exists' : 'No user', 
      loading 
    });
  }

  if (loading) {
    if (process.env.NODE_ENV === 'development') {
      console.log('ProtectedRoute: Showing loading spinner');
    }
    return <LoadingSpinner message="Checking authentication..." />;
  }

  if (!currentUser) {
    if (process.env.NODE_ENV === 'development') {
      console.log('ProtectedRoute: No user, redirecting to signin');
    }
    return <Navigate to="/signin" />;
  }

  if (process.env.NODE_ENV === 'development') {
    console.log('ProtectedRoute: User authenticated, showing children');
  }
  return children;
});

ProtectedRoute.displayName = 'ProtectedRoute';

export default ProtectedRoute;
